import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: 'root'
})
export class CommonUtility {
    constructor(private snackBar: MatSnackBar)
    {

    }
setformControlError(formcontrol:any,controlName:string)
{
  formcontrol.controls[controlName].markAsDirty();
  formcontrol.controls[controlName].markAsTouched();
  formcontrol.controls[controlName].setErrors({ 'invalid': true });
}

getFormControlError(formcontrol:any,controlName:string)
{
  return formcontrol.controls[controlName].invalid && (formcontrol.controls[controlName].dirty || formcontrol.controls[controlName].touched);
}



alertMsg(msg:any,callBackFun:any,success:boolean)
{ console.log("alertMsg");
  if(success)
  {
    this.snackBar.open(msg, callBackFun, {
    duration: 4000,
    verticalPosition: 'top',
    panelClass:['snackbarSUCCESS']
    });
  }
  else
  {
    this.snackBar.open(msg, callBackFun, {
      duration: 4000,
      verticalPosition: 'top',
      panelClass:['snackbarDANGER']
      });
  }
}

getStatusValue(status:number)
{
  var result ='';
  status = Number(status);
    switch(status) {
      case 0: {
        result = 'InActive';
        break;
     }
      case 1: {
         result = 'Active';
         break;
      }
      case 2: {
        result = 'Lock';
         break;
      }
      case 3: {
        result = 'Block';
         break;
      }
      case 4: {
        result = 'Deactive agency';
         break;
      }
      default: {
         //statements;
         break;
      }
   }
 return result;
 }

}
